import React from "react";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";
import "./index.scss";

const FarmNameCell = ({ value, row, setAsFavorite }) => {
  return (
    <div data-testid="farm-name-cell" className="farm-name-cell">
      <ReactTooltip className="tooltip" effect="solid" />
      <span
        data-tip="Add this farm to your favorites"
        data-testid="favorite"
        className={`favorite ${
          row?.original?.properties?.is_favorite
            ? "icon-star-filled"
            : "icon-star"
        }`}
        onClick={() => setAsFavorite(row.original.properties.farm_id)}
        aria-hidden
      />
      <div className="details">
        <div
          className={`${
            row.isExpanded ? "cell-header" : "cell-header -hidden"
          }`}
        >
          Farm Name
        </div>
        <span className="name">{value}</span>
      </div>
    </div>
  );
};

FarmNameCell.propTypes = {
  value: PropTypes.string.isRequired,
  row: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  setAsFavorite: PropTypes.func.isRequired,
};

export default FarmNameCell;
